(function () {
  "use strict";

  async function collectionCard() {
    const mainContainer = document.querySelector(".collection-products");
    if (!mainContainer) {
      return;
    }

    const productCard = Array.from(mainContainer.children);

    if (!productCard.length) {
      return;
    }

    ///////////////////////////DATA STARTS HERE/////////////////////////////////////

    const IMAGE = [ 
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_HIMAWARIHORRORS.webp",
        LINK: "/collections/himawarikeep",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_SWOOPYBOYHOODIE.webp?v=1778650508",
        LINK: "/collections/sale",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC-KirstyMcIntyre.webp?v=1771397909",
        LINK: "/collections/kirsty-mcintyre",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPCEveryBodyWins.webp?v=1721882526",
        LINK: "/collections/all",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_HATS.webp?v=1766543261",
        LINK: "/collections/headwear",
      },
      {
        IMAGE:
          "//cdn.shopify.com/s/files/1/0549/8005/1111/files/VPC_AnnieWalter.webp?v=1757049289",
        LINK: "/collections/annie-walter",
      },
    ];

    ////////////////////////DATA ENDS HERE//////////////////////////////////

    const style = document.createElement("style");
    style.textContent = `
    .convx__value-proposition-cards-link{
      position: absolute;
      inset: 0;
      display: block;
      height: 100%;
      width: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border: 2px solid #000;
    }
    `;
    document.head.append(style);

    shuffle(IMAGE);
    shuffle(IMAGE);
    if (productCard.length < 5) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
    } else if (productCard.length < 16) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
    } else if (productCard.length < 24) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
      productCard[Math.min(11, productCard.length - 1)].before(
        createImgCard(IMAGE[1])
      );
    } else if (productCard.length >= 24) {
      productCard[Math.min(6, productCard.length - 1)].before(
        createImgCard(IMAGE[0])
      );
      productCard[Math.min(11, productCard.length - 1)].before(
        createImgCard(IMAGE[1])
      );
      productCard[Math.min(16, productCard.length - 1)].before(
        createImgCard(IMAGE[2])
      );
      productCard[Math.min(20, productCard.length - 1)].before(
        createImgCard(IMAGE[3])
      );
      const cards = document.querySelectorAll('.collection-products .collection-pvc-card');
        // Check if there are any elements with this class
      let isMobile = window.matchMedia('(max-width: 992px');
      if(!isMobile.matches) {
        if (cards.length > 0) {
          // Apply style to the last element
          const lastCard = cards[cards.length - 1];
          lastCard.style.display = 'none';
        }
      }
      window.addEventListener('resize', () => {
        if(isMobile.matches) {
          if (cards.length > 0) {
            // Apply style to the last element
            const lastCard = cards[cards.length - 1];
            lastCard.style.display = 'block';
          }
        } else {
          if (cards.length > 0) {
            // Apply style to the last element
            const lastCard = cards[cards.length - 1];
            lastCard.style.display = 'none';
          }
        }
      })
    }

    // productCard[Math.min(6, productCard.length - 1)].before(
    //   createImgCard(IMAGE[0])
    // );
    // productCard[Math.min(11, productCard.length - 1)].before(
    //   createImgCard(IMAGE[1])
    // );
    // productCard[Math.min(16, productCard.length - 1)].before(
    //   createImgCard(IMAGE[2])
    // );

    function createImgCard(ITEM) {
      const div = document.createElement("div");
      div.classList.add(
        "spf-col-xl-4",
        "spf-col-lg-4",
        "spf-col-md-6",
        "spf-col-sm-6",
        "spf-col-6",
        "collection-pvc-card"
      );

      const div2 = document.createElement("div");
      div2.classList.add(
        "spf-product-card",
        "spf-product-card__left",
        "spf-product-card__template-1"
      );

      const a = document.createElement("a");
      a.classList.add("convx__value-proposition-cards-link");
      a.setAttribute("href", ITEM.LINK);
      a.style.backgroundImage = `url("${ITEM.IMAGE}")`;

      // const img = document.createElement("img");
      // img.classList.add("convx__value-proposition-cards-img");
      // img.setAttribute("src", ITEM.IMAGE);

      // a.append(img);
      div2.append(a);
      div.append(div2);

      return div;
    }

    function shuffle(array) {
      array.sort(() => Math.random() - 0.5);
    }
  }

  let added = false;

  function onDOMContentLoaded() {
    const observer = new MutationObserver(onMutate);
    observer.observe(document.documentElement, {
      attributes: true,
      attributesFilter: ["class"],
    });
    paginationListen();
  }

  function paginationListen() {
    // Add event listeners to pagination links
    document.addEventListener("click", function (event) {
      if (event.target.matches("#pagination a")) {
        added = false;
      }
    });
  }

  function onMutate(mutationList, observer) {
    const card = document.querySelector(".convx__value-proposition-cards-link");
    for (const mutation of mutationList) {
      if (
        mutation.target.classList.contains("spf-status-loaded") &&
        !added &&
        !card
      ) {
        setTimeout(collectionCard, 200);
        added = true;
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
